// removed by extract-text-webpack-plugin
module.exports = {"select":"select--1-3si","value":"value--1-Pg3"};